export default function AppEntry() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
                随时随地吃瓜
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                将五一吃瓜网添加到手机桌面，随时随地追踪最新网络热门事件。
                支持 iOS 与 Android 系统，无需下载 App，浏览器一键直达。
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 添加到桌面
                </a>
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 添加到桌面
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20modern%20illustration%20of%20smartphone%20displaying%20news%20feed%20with%20warm%20coral%20and%20amber%20color%20palette%2C%20clean%20minimalist%20mobile%20app%20interface%20mockup%2C%20editorial%20news%20reader%20aesthetic%2C%20no%20text%2C%20flat%20modern%20illustration%20style&width=400&height=400&seq=app-qr-placeholder&orientation=squarish"
                  alt="五一吃瓜网移动端入口展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}